/* ACTION CREATOR FUNCTIONS

Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects

*/

import * as types from './types';
import store from '../store';
import api from '../../utils/api/base_api';
import surchx_api from '../../utils/api/surchx_base_api';
import surchx_api_test from '../../utils/api/surchx_base_api-test';

const setMerchant = data => ({
    type: types.SET_MERCHANT,
    payload: { ...data },
});

const setMerchantId = data => ({
    type: types.SET_MERCHANT_ID,
    payload: { data },
});

const setMerchantIdTest = data => ({
    type: types.SET_MERCHANT_ID_TEST,
    payload: { data },
});

const editMerchant = data => {
    api.defaults.headers['Authorization'] =  "Bearer " + store.getState().tokenReducer.tokens.loginToken ;

    return {
        type: types.EDIT_MERCHANT,
        payload: api.post('edit_merchant', data),
    };
};

const getMerchant = data => {
    api.defaults.headers['Authorization'] =  "Bearer " + store.getState().tokenReducer.tokens.loginToken ;

    return {
        type: types.GET_MERCHANT,
        payload: api.get(`merchant_info?merchants_id=${data.merchants_id}`),
    };
}

const getMerchantInvoiceList = data => {
    surchx_api.defaults.headers['Authorization'] =  "Bearer " + store.getState().tokenReducer.tokens.bearerToken;
    const mid = store.getState().merchantReducer.merchant.merchant_id;

    return {
        type: types.GET_MERCHANT_INVOICE_LIST,
        payload: surchx_api.get(`/merchant/${mid}/invoice?start=${data.startDate.format('YYYY-MM-DD')}&end=${data.endDate.format('YYYY-MM-DD')}`),
    };
}

const getMerchantInvoice = data => {
    surchx_api.defaults.headers['Authorization'] =  "Bearer " + store.getState().tokenReducer.tokens.bearerToken;
    const mid = store.getState().merchantReducer.merchant.merchant_id;

    return {
        type: types.GET_MERCHANT_INVOICE,
        payload: surchx_api.get(`/merchant/${mid}/invoice/${data.id}`, { responseType: 'blob', headers: { Accept: 'application/pdf'}}),
    };
}

const getMerchantStatement = data => {
    surchx_api.defaults.headers['Authorization'] =  "Bearer " + store.getState().tokenReducer.tokens.bearerToken;
    const mid = store.getState().merchantReducer.merchant.merchant_id;

    return {
        type: types.GET_MERCHANT_STATEMENT,
        payload: surchx_api.get(`/merchant/${mid}/invoice/${data.id}`, { responseType: 'blob', headers: { Accept: 'text/csv'}}),
    };
}

const setSurchargeActive = data => {
    return {
        type: types.SET_SURCHARGE_ACTIVE,
        payload: { data },
    };
}

const setSurchxStatus = data => {
    return {
        type: types.SET_INTERPAYMENTS_STATUS,
        payload: { data },
    };
}

const setMerchantStatus = data => ({
    type: types.SET_MERCHANT_STATUS,
    payload: { data },
});

export {
    setMerchant,
    setMerchantId,
    setMerchantIdTest,
    editMerchant,
    getMerchant,
    setSurchargeActive,
    setSurchxStatus,
    setMerchantStatus,
    getMerchantInvoiceList,
    getMerchantInvoice,
    getMerchantStatement
};



// WEBPACK FOOTER //
// ./src/redux/merchant/actions.js